module.exports = __webpack_public_path__ + "static/media/SPONSORS.4b21d710.png";